// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"8709b4c9d13c0cfe6a7e","293":"0ae3e74060703cbb5741","518":"5a8c85feb3edc3a3d67e","779":"b05a5ffb412f7bca68d2"}[chunkId] + ".js";
};